import IndexedDB from "@/helpers/IndexedDB.js";

import store from "@/store";

// const NameDB = 'formularios';
const Observable = () => {
  const idForm = store.state.resource.idForm;
  const idPage = store.state.resource.idPage;
  const idCounter = store.state.resource.idCounter;
  const questionsByPage = store.state.resource.questionsByPage;
  const counter = store.state.resource.counter;

  return { idForm, idPage, idCounter, questionsByPage, counter };
};

const getAllPages = async () => {
  const { idForm } = Observable();

  if (idForm !== null) {
    const allPages = await IndexedDB.where_order_sortBy("pages", { id_form: idForm }, "date_create");
    return allPages;
  }
  return [];
};

const getAllQuestion = async () => {
  const { idForm } = Observable();

  if (idForm !== null) {
    const allPages = await getAllPages();
    if (allPages.length === 1) return allPages[0].questions;

    let joinQuestion = [];

    for (var i in allPages) {
      joinQuestion = [...joinQuestion, ...allPages[i].questions];
    }
    return joinQuestion;
  }
  return [];
};

const getQuestionsByPage = async () => {
  const { idForm, idPage } = Observable();
  if (idForm !== null && idPage !== null) {
    const pages = await IndexedDB.where_("pages", { id_form: idForm, key: idPage }, { query: "first" });
    return pages.questions;
  }
  return [];
};

const getListForm = async ({ company, uuid }) => {
  const Formularios = await IndexedDB.where_("formulario", { companyId: company, uuid: uuid }, { query: "each" });
  return Formularios;
};

const existFormById = async id_Form => {
  const key = await IndexedDB.getKey("formulario", id_Form);
  return key;
};

const getForm = async (id_Form = null) => {
  const { idForm } = Observable();

  const keyForm = id_Form !== null ? id_Form : idForm;

  const form = await IndexedDB.where_("formulario", { key: keyForm }, { query: "each" });
  if (form) return form[0];
  return null;
};

const getFormVersion = async (id_Form = null, version = 1) => {
  const { idForm } = Observable();

  const keyForm = id_Form !== null ? id_Form : idForm;

  const form = await IndexedDB.where_("formulario", { key: keyForm, version: version }, { query: "each" });
  if (form) return form[0];
  return null;
};

const getDependencies = async () => {
  const { idForm } = Observable();

  if (idForm !== null) {
    const { dependencias, simple, compound, listener, key } = await IndexedDB.where_(
      "dependencias",
      { id_form: idForm },
      { query: "first" }
    );
    return { dependencias, simple, compound, listener, key };
  }
};

const getCounter = async () => {
  //Retorna un objeto
  const { idForm } = Observable();
  if (idForm !== null) {
    const counter = await IndexedDB.where_("contadores", { id_form: idForm }, { query: "each" });
    return counter[0];
  }
  return null;
};

const setCounter = async () => {
  const { idCounter, counter } = Observable();
  await IndexedDB.update("contadores", { contador: counter }, idCounter);
};

const getColumnsOrigin = async () => {
  const { idDependence, idForm } = Observable();
  const result = await IndexedDB.where_("dependencias", { id_form: idForm }, { query: "first" });
  const { columns } = result;
  return columns;
};

//AGREGO, ACTUALIZO Y ELIMINA PREGUNTAS
const setQuestion = async () => {
  const { idPage, questionsByPage } = Observable();
  await IndexedDB.update("pages", { questions: questionsByPage }, idPage);
};

const updatePages = async (idPage, pages) => {
  await IndexedDB.update("pages", { questions: pages }, idPage);
};

const setColumnsOrigin = async ObjectColumns => {
  const { idDependence } = Observable();
  await IndexedDB.update("dependencias", { columns: ObjectColumns }, idDependence);
};

const setFormulario = async ({ groupId, method, name, version = 1 }) => {
  const { idForm } = Observable();
  await IndexedDB.update("formulario", { groupId, method, name, version }, idForm);
};
const deleteColumns = async newObjet => {
  const { idDependence } = Observable();
  await IndexedDB.update("dependencias", { columns: newObjet }, idDependence);
};

const deletePage = async key => {
  await IndexedDB.deleteKey("pages", key);
};

const createPage = async page => {
  /*	
	 page = {
		id_form: idForm,		
		questions: []
		date_create?
	}
	*/
  const id_page = await IndexedDB.save("pages", page);
  return id_page;
};

const createContador = async contador => {
  /*	
	contador = {
		id_form: idForm,
		contador: this.contador
		date_create?
	}
	*/
  const id_contador = await IndexedDB.save("contadores", contador);
  return id_contador;
};

const createDependence = async dependence => {
  /*	
	dependencias = {
		id_form: idForm,
		simple: {},
		dependencias: [],
		listener: {},
		compound: {}
		columns: {}
	}
	*/
  const id_dependencia = await IndexedDB.save("dependencias", dependence);
  return id_dependencia;
};

const createForm = async (data, formID = null) => {
  //si formID no es null se entendera que es un formulario a actualizar
  /*
	 data = {
		method: 'create' || 'update',
		companyId: user.companyID,
		name: '',
		groupId: '',
		uuid: user.uuid
	}
	*/
  const keyForm = await IndexedDB.save("formulario", data, formID);
  return keyForm;
};

const clearIndexDbByIdForm = async (key = null) => {
  const { idForm } = Observable();
  let keyForm = idForm;
  if (key !== null) keyForm = key;
  await IndexedDB.truncateFilter("contadores", { id_form: keyForm });
  await IndexedDB.truncateFilter("dependencias", { id_form: keyForm });
  await IndexedDB.truncateFilter("formulario", { key: keyForm });
  await IndexedDB.truncateFilter("pages", { id_form: keyForm });
};

const updateFormType = async formType => {
  const { idForm } = Observable();
  await IndexedDB.update("formulario", { formType }, idForm);
};

const ativeOneForm = async idForm => {
  await IndexedDB.update("formulario", { active: true }, idForm);
};

const inactiveAllForms = async () => {
  await IndexedDB.updateStateForm("formulario");
};

export {
  getForm,
  getFormVersion,
  existFormById,
  getListForm,
  getAllPages,
  getDependencies,
  getQuestionsByPage,
  getCounter,
  getAllQuestion,
  getColumnsOrigin,
  setColumnsOrigin,
  setQuestion,
  setFormulario,
  setCounter,
  createForm,
  createPage,
  createDependence,
  createContador,
  updatePages,
  updateFormType,
  deleteColumns,
  deletePage,
  clearIndexDbByIdForm,
  inactiveAllForms,
  ativeOneForm
};
